import { OnchainAsset } from './onchainTypes';

const SOLANA_RPC = 'https://api.mainnet-beta.solana.com';

export async function readSolanaWalletAssets(address: string, walletId: string): Promise<OnchainAsset[]> {
  const assets: OnchainAsset[] = [];
  // 1. Solde SOL
  const solRes = await fetch(SOLANA_RPC, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      jsonrpc: '2.0', id: 1, method: 'getBalance', params: [address]
    })
  });
  const solData = await solRes.json();
  if (solData.result && solData.result.value) {
    const solBalance = solData.result.value / 1e9;
    if (solBalance > 0.0001) {
      assets.push({ symbol: 'SOL', quantity: solBalance, chain: 'solana', walletId });
    }
  }
  // 2. SPL tokens
  const splRes = await fetch(SOLANA_RPC, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      jsonrpc: '2.0', id: 2, method: 'getTokenAccountsByOwner',
      params: [address, { programId: 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA' }, { encoding: 'jsonParsed' }]
    })
  });
  const splData = await splRes.json();
  if (splData.result && Array.isArray(splData.result.value)) {
    for (const acc of splData.result.value) {
      const info = acc.account.data.parsed.info;
      const mint = info.mint;
      const tokenAmount = info.tokenAmount;
      const quantity = parseFloat(tokenAmount.amount) / Math.pow(10, tokenAmount.decimals);
      if (quantity > 0.0001) {
        assets.push({ symbol: mint, contractAddress: mint, quantity, chain: 'solana', walletId });
      }
    }
  }
  return assets;
}
